'use client'

import {useEffect, useRef} from 'react'
import {usePathname, useSearchParams} from 'next/navigation'
import {pageView} from '@local/utils/gtm'

export const NavigationEvents = () => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const isVirtual = useRef(false)

	useEffect(() => {
		const href = `${pathname}${searchParams?.toString() || ''}`

		pageView({
			pageTitle: document.title,
			pageLocation: href,
			virtual: isVirtual.current,
		})

		isVirtual.current = true
	}, [pathname, searchParams])

	return null
}
